// Update contents object below
const contents = {
  header: 'BASF', //update with your client name
  logoTooltip: {
    href: 'https://www.intel.com/wonderful', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'There is More to Choosing a Car Color Than Meets the Eye',
    copy: ''
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption: ''
      },
      {
        class: 'photo2',
        caption:
          'FakeCatcher uses Photoplethysmography (PPG), which detects vein color change in video pixels. FakeCatcher converts those PPG signals into maps and builds a deep-learning approach to classify them as fake and real. The PPG map extraction cannot be replicated, so this technology cannot be used by criminals online.'
      },
      {
        class: 'photo3',
        caption: 'Caption: TK –Photocredit: Bogdan Dinca for CORE'
      },
      {
        class: 'photo4',
        caption:
          'Bluewhite and Intel worked with Federated Wireless to deploy a 5G private wireless network alongside tractors using Bluewhite’s autonomous platform at a vineyard in California’s San Joaquin Valley. (Photo credit: Bluewhite)'
      },
      {
        class: 'photo5',
        caption:
          'An aerial view of the vineyard in California’s San Joaquin Valley where the pilot program took place. Alon Ascher hopes that with this new technology will see “the young generation coming back to the farm, as robotic farmers, with pride and joy.” (Photo credit: Bluewhite)'
      }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://sponsorcontent.cnn.com/interactive/intel/', //where the cta button click drives to
    copy: '' //tooltip content
  }
};

export default contents;
